import React from 'react';
import { Button, Spin, Checkbox, Form, Icon, Input, message, Dropdown, Menu, Card, Row, Col, Layout, Select, Divider, Drawer } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { auth, database, functions } from '../firebase/firebase';
import ReactPlayer from 'react-player'
import Moment from 'moment';
import localization from 'moment/locale/es'
import AutoPlaySilentVideo from './AutoPlaySilentVideo';
import { userSignOut } from "appRedux/actions/Auth";

import {
	hideMessage,
	showAuthLoader,
	userFacebookSignIn,
	userGithubSignIn,
	userGoogleSignIn,
	userSignIn,
	userTwitterSignIn
} from 'appRedux/actions/Auth';

import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress/index';
import Topbar from './Topbar/index';
import HorizontalDefault from './Topbar/HorizontalDefault/index';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const htmlContent = `
<!DOCTYPE  html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="es" lang="es"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"/><title>1 Información para Prescribir Amplia (IPP) Norutec®</title><meta name="author" content="Estefania Garcia Contreras"/><style type="text/css"> * {margin:0; padding:0; text-indent:0; }
 p { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; margin:0pt; }
 h1 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }
 .s1 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 6.5pt; vertical-align: 2pt; }
 .s2 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; vertical-align: 2pt; }
 .s3 { color: black; font-family:"Arial Narrow", sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }
 .s4 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }
 .s5 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; }
 .s6 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; }
 .s7 { color: black; font-family:"Arial Narrow", sans-serif; font-style: italic; font-weight: normal; text-decoration: underline; font-size: 10pt; }
 .s8 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }
 .s9 { color: black; font-family:ArialNarrow-BoldItalic, sans-serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 10pt; }
 .h2 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 6.5pt; }
 .s10 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }
 .s11 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 10pt; }
 .s12 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }
 .a, a { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }
 li {display: block; }
 #l1 {padding-left: 0pt;counter-reset: c1 2; }
 #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }
 #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }
 #l2 {padding-left: 0pt;counter-reset: c2 1; }
 #l2> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:"Arial Narrow", sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }
 #l2> li:first-child>*:first-child:before {counter-increment: c2 0;  }
 table, tbody {vertical-align: top; overflow: visible; }
</style></head><body><p style="padding-top: 4pt;padding-left: 46pt;text-indent: 0pt;text-align: center;">INFORMACIÓN PARA PRESCRIBIR AMPLIA</p><p style="text-indent: 0pt;text-align: left;"><br/></p><h1 style="padding-top: 5pt;padding-left: 203pt;text-indent: 0pt;line-height: 11pt;text-align: left;">NORUTEC<span class="s1">®</span></h1><ol id="l1"><li data-list-text="2."><h1 style="padding-left: 76pt;text-indent: -17pt;line-height: 11pt;text-align: left;">DENOMINACIÓN GENÉRCIA:</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Ilaprazol.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="3."><h1 style="padding-top: 5pt;padding-left: 76pt;text-indent: -17pt;text-align: left;">FORMA FARMACÉUTICA Y FORMULACIÓN:</h1><p style="padding-left: 5pt;text-indent: 0pt;line-height: 23pt;text-align: left;">Tableta de liberación retardada. Cada tableta contiene contiene:</p><p style="padding-left: 10pt;text-indent: 0pt;text-align: left;">Ilaprazol                   10 o 20 mg</p><p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Excipiente cbp.                 1 tableta</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="4."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">INDICACIONES TERAPÉUTICAS:</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">NORUTEC<span class="s2">® </span>(tabletas de liberación retardada) está indicado en:</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">Tratamiento a corto plazo de esofagitis erosiva: está indicado para el tratamiento a corto plazo (hasta 8 semanas) de todos los grados de esofagitis erosiva.</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">Tratamiento a corto plazo de úlcera duodenal: está indicado para el tratamiento a corto plazo (hasta 4 semanas) de la úlcera duodenal.</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">Tratamiento a corto plazo de úlcera gástrica: está indicado para el tratamiento a corto plazo (durante 4-6 semanas) de la úlcera gástrica.</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Erradicación de <i>Helicobacter pylori</i>: está indicado para la erradicación de <i>H. pylori</i>, en combinación con el esquema antibiótico (amoxicilina y claritromicina) para reducir el riesgo de recurrencia de úlcera gástrica o duodenal.</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">La enfermedad ácido-péptica es un grupo de entidades nosológicas de fisiopatología común en la que la hipersecreción de ácido es el elemento principal, el <i>H. pylori </i>tiene un papel importante y cuyo espectro abarca a la enfermedad por reflujo gastroesofágico (que incluye esofagitis no erosiva y esofagitis erosiva), úlcera péptica (sea duodenal o gástrica), gastritis y dispepsia no ulcerosa o funcional. En este contexto, es importante mencionar que la farmacodinamia del ilaprazol es precisamente inhibiendo dicha hipersecreción de ácido.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="5."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">FARMACOCINÉTICA Y FARMACODINAMIA:</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Farmacocinética:</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Absorción y distribución:</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">NORUTEC<span class="s2">® </span>es una formulación de tableta con recubrimiento entérico (gastro-resistente) de ilaprazol como un racemato de dos enantiómeros activos. El ilaprazol es inestable en ácido. La absorción del ilaprazol es rápida, con concentraciones pico en plasma que se presentan aproximadamente 3-4 horas después de la administración de una dosis de 20 mg. La ingesta de alimentos retarda la absorción del ilaprazol, aunque esto no tiene ninguna influencia significativa sobre el efecto del ilaprazol sobre la acidez intragástrica. En el rango de dosis de 10 a 40 mg, los valores de ABC medios y de Cmáx para el ilaprazol se incrementan con dosis cada vez mayores de ilaprazol. El ilaprazol exhibe 35% de biodisponibilidad con una sola dosis.</p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">El volumen aparente de distribución en el estado estable en sujetos sanos es aproximadamente 24.11 L. El ilaprazol se une a proteínas plasmáticas en un 98.9%.</p><p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">El perfil farmacocinético del ilaprazol fue determinado en 30 sujetos sanos después de la administración diaria repetida de 10 mg, 20 mg y 40 mg de ilaprazol en un período de cinco días. Los resultados se muestran en la siguiente tabla:</p><p style="padding-top: 4pt;padding-left: 26pt;text-indent: 0pt;text-align: center;">Tabla 1. Parámetros farmacocinéticos del ilaprazol el día 5 después de la administración oral durante 5 días:</p>

<img  alt="image" src="benequer1.jpg"/>

`;

class Tarjeton extends React.Component {

	constructor() {
		super();
		this.state = {
			loading: false,
			subject: "Dudas sobre productos Chinoin®",
			message: '',
			showVideo: false,
			videoId: '',
			showVisit: false,
			selectedVisit: '',
			visitStatus: "",
			videoTitle: '',
			videoCategory: '',
			email: '',
			contactEmail: '',
			contactSubject: 'Dudas sobre productos Chinoin®',
			contactMessage: '',
			handleVisitLoader:false,

		};
		this.handleSubmit = this.handleSubmit.bind(this);
		//this.setRedirect = this.setRedirect.bind(this);
		//this.handleSignIn = this.handleSignIn.bind(this);
		this.handleSubject = this.handleSubject.bind(this);
		this.handleVisits = this.handleVisits.bind(this);

		this.handleEmail = this.handleEmail.bind(this);
		this.handleMessage = this.handleMessage.bind(this);

	}

	
	getInfo(user) {
		//console.log("ALL USER INFO CALLED");
		var _this = this;

		database
			.collection("users")
			.where("email", "==", user.email)
			.get()
			.then(function (querySnapshot) {

				querySnapshot.forEach(function (doc) {
					_this.setState({ user: doc.data(), userId: doc.id });
					console.log("ID: " + doc.id);
				});
			})
			.catch(function (error) {
				//console.log("Error getVideosInformation :", error);
			});
	}
	ref = player => {
		this.player = player
	}

	componentDidMount() {
		var _this = this;

		auth.onAuthStateChanged(user => {
			if (user) {
				_this.getInfo(user);
			}
		});
	}

	handleVisits() {
		console.log("handleVisits")
		this.setState({handleVisitLoader:true})

		var addMessage = functions.httpsCallable('medicalvisit');
		Moment().locale('es', localization)

		var dateMessage = Moment(new Date())
			.locale('es')
			.format('D [de] MMMM [del]  YYYY');
		var _this = this;
		addMessage({
			userId: this.state.userId,

			date: dateMessage,
			method: this.state.selectedVisit
		})
			.then(function (result) {
				console.log("sucess")
				_this.setState({handleVisitLoader:false})

				// Read result of the Cloud Function.
				_this.setState({ visitStatus: "success" })
				//var sanitizedMessage = result.data.text;
			})
			.catch(function (error) {

				_this.setState({ visitStatus: "error" })
				_this.setState({handleVisitLoader:false})

				// Getting the Error details.
				var code = error.code;
				var message = error.message;
				var details = error.details;

				console.log("Function error")
				console.log(code)
				console.log(message)
				//console.log(details)
				// ...
			});
	}
	handleSubmit = (e) => {
		e.preventDefault();
	
		if(this.state.contactEmail != "" && this.state.contactSubject != "" && this.state.contactMessage != ""){
			if(/\S+@\S+\.\S+/.test(this.state.contactEmail)){
			//	if(this.state.contactEmail.includes("@") &&this.state.contactEmail.includes(".")){

			var addMessage = functions.httpsCallable('contactform');

		var dateMessage = Moment(new Date())
			.locale('es')
			.format('D [de] MMMM [del]  YYYY');
		var _this = this;
		addMessage({
			email: this.state.contactEmail,
			subject: this.state.contactSubject,
			date: dateMessage,
			message: this.state.contactMessage
		})
			.then(function (result) {
				console.log("sucess")
				alert("Enviado!")
				_this.setState({ contactEmail: '', contactSubject: '', contactMessage: '' })
				// Read result of the Cloud Function.
				_this.setState({ visitStatus: "success" })
				//var sanitizedMessage = result.data.text;
			})
			.catch(function (error) {

				_this.setState({ visitStatus: "error" })

				// Getting the Error details.
				var code = error.code;
				var message = error.message;
				var details = error.details;

				console.log("Function error")
				console.log(code)
				console.log(message)
				//console.log(details)
				// ...
			});
		}else{
			alert("Correo electrónico inválido")
		}
		}else{
			alert("Por favor llene todos los campos")
		}

	};

	handleSubject(e) {
		console.log(e);
		this.setState({ contactSubject: e});
	}
	handleMessage(e) {
		console.log(e.target.value);
		this.setState({ contactMessage: e.target.value });
	}
	handleEmail(e) {
		console.log(e.target.value);
		this.setState({ contactEmail: e.target.value });
	}
	componentDidUpdate() { }

	render() {

		const handleVideoClick = (videoid, videoTitle, videoCategory) => {
	
			console.log('The link was clicked.');
			this.setState({ showVideo: true, videoId: videoid, videoTitle: videoTitle, videoCategory: videoCategory });
		}

		return (
			<div className="scrollable">


				<HorizontalDefault />
				
				<div class="menu-mobile">

<div>
	<Row span={24}>

		<Col span={1}></Col>
		<Col span={3}>
			<div onClick={() => this.setState({ visible: true })}><Icon type="menu" style={{ fontSize: '36px', color: '#fff' }} /> </div>
		</Col>
		<Col span={4}><a href="/"><img id="home-icon" src={require('../assets/images/home_icon.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></a></Col>
		<Col span={7}>
			<img src={require('../assets/images/logo-main-small.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
		</Col>
		<Col span={2}></Col>
		<Col span={6}>
			<img id="slight-top" src={require('../assets/images/norutec.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
		</Col>
		<Col span={1}></Col>

	</Row>

	<Drawer


		placement="right"
		closable={false}
		visible={this.state.visible}
	>
		<br></br>
		<Icon type="close" style={{ fontSize: '30px', color: '#fff', float: 'right' }} onClick={() => this.setState({ visible: false })} />
		<a href="/"><p class="drawer-item">ACERCA DE</p></a>
		<Divider />
		<a href="/profesional-salud"><p class="drawer-item">PROFESIONAL DE LA SALUD</p></a>
		<ul>
			<li><a href="/educacion-medica"><p class="drawer-subitem">EDUCACIÓN MÉDICA CONTINUA</p></a><Divider></Divider></li>

			<li><a href="/informacion-producto"><p class="drawer-subitem">INFORMACIÓN DE PRODUCTO</p></a><Divider></Divider></li>

			<li><a href="/experiencia-clinica"><p class="drawer-subitem">EXPERIENCIA CLÍNICA</p></a><Divider></Divider></li>
		</ul>
		<a href="/gastrobalance"><p class="drawer-item">GASTROBALANCE</p></a>
		<Divider />
		<a href="/#contacto"><p class="drawer-item">CONTACTO</p></a>
		<Divider />
		{(this.state.user != {} && this.state.user != null) ? <a onClick={() => this.props.userSignOut()}><p class="drawer-item">CERRAR SESIÓN</p></a> : null}
	</Drawer>
</div>


</div>

				<div className="">
				<div class="mobile-spacer">
						<br></br>	<br></br>	<br></br>	<br></br>	<br></br>
					</div>

					<Row>
					<Col lg={8} md={6} sm={1} xs={1}></Col>
					<Col lg={8} md={12} sm={22} xs={22}>
					<img src={require('../assets/images/benequer1.jpg')} alt="innovacion_chinoin" title="innovacion_chinoin" />
					<img src={require('../assets/images/benequer2.jpg')} alt="innovacion_chinoin" title="innovacion_chinoin" />

						</Col>
						<Col lg={8} md={6} sm={1} xs={1}></Col>
					</Row>
					<br></br><br></br>
					<div class="desktop-spacer">
					<br></br><br></br><br></br><br></br><br></br><br></br><br></br>
										</div>
								

					<Row id="footer-solid">
						<Col span={2}>

						</Col>
						<Col lg={4} md={4} sm={20} xs={20}>
							<ul className="list-no-bullet">

								<li>
									<br></br>
									<Row>
										<Col lg={0} md={0} sm={2} xs={2}></Col>

										
										<Col lg={18} md={18} sm={18} xs={18}>
										<span class="footer-small-text">Plataforma académica patrocinada por Productos Farmacéuticos Chinoin®<br></br><br></br><br></br></span>

											<span class="footer-small-text">Productos Farmacéuticos Chinoin®<br></br>

												Lago Tangañica #18<br></br>
												Colonia Granada, 11520<br></br>
												México, D.F.<br></br>
												(55) 5262 31 00<br></br>
												Fax: (55) 5531 43 49<br></br>
												ventas@chinoin.com</span>
										</Col>
									</Row>
								</li>
							</ul>
						</Col>
						<Col lg={4} md={4} sm={4} xs={4}></Col>

						<Col lg={4} md={4} sm={19} xs={19}>
							<ul id="social-ul" className='margin-left' >
								<li><img class="footer-logo-norutec" src={require('../assets/images/norutec_alone.png')} /></li>
								<br></br>	
								<li><img class="footer-logo-norutec" src={require('../assets/images/benequer.png')} /></li>

								<br></br>	
								<li><img class="footer-logo-brand" src={require('../assets/images/talnesis.png')} /></li>
								<br></br>	
								<li><img class="footer-logo-brand-gelan" src={require('../assets/images/gelan-small.webp')} /></li>
								<br></br>
								<li><img class="footer-logo-brand-gelan" src={require('../assets/images/anara.png')} /></li>
								<br></br>	<br></br>	
								<li><img class="footer-logo-brand-inter" src={require('../assets/images/logo-intersistemas.png')} />
									<br></br>
									<span id="dev-text"> Desarrollado por Intersistemas S.A de C.V</span>
								</li>
								<br></br>		<br></br>			<br></br>
							</ul>
						</Col>
						<Col lg={4} md={4} sm={4} xs={4}>

						</Col>
						<Col lg={4} md={4} sm={20} xs={20}>
							<span class="regular-text">Accesos rápidos</span>
							<ul className="list-no-bullet">
								<li><a href="/#acerca"> <span className='footer-links'>Acerca de</span></a></li>
								<li><a href="profesional-salud"> <span className='footer-links'>Acceso Profesional de la Salud</span></a></li>
								<li><a href="gastrobalance"> <span className='footer-links'>Gastrobalance</span></a></li>
								<li><a href="puntosdeventa"> <span className='footer-links'>Puntos de venta</span></a></li>
								<li><a href="https://www.chinoin.com/"> <span className='footer-links'>Sobre Chinoin</span></a></li>
							<li><a href="https://www.chinoingastroinnovacion.com/aviso" target="_blank"> <span className='footer-links'>Aviso de privacidad</span></a></li>
								<div className='mobile-spacer'>
								<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
							</div>
								

							</ul>
						</Col>

					</Row>
					<a href="https://www.chinoin.com/" target="_blank"><img id="corner-logo" src={require('../assets/images/esquina.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></a>

					<div id="social">
						<ul id="social-ul">
								<li className='social-list'><a href="https://www.facebook.com/ChinoinProductosFarmaceuticos" target="_blank"><img class='social-icon' src={require('../assets/images/face.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.instagram.com/chinoinpf/" target="_blank"><img class='social-icon' src={require('../assets/images/insta.webp')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.linkedin.com/company/chinoinpf/" target="_blank"><img class='social-icon' src={require('../assets/images/in.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.tiktok.com/@chinoinpf?is_from_webapp=1&sender_device=pc" target="_blank"><img class='social-icon' src={require('../assets/images/tiktok.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://twitter.com/ChinoinPF" target="_blank"><img class='social-icon' src={require('../assets/images/twitter.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.youtube.com/channel/UC3SguU-Dc1L61rFbBm8Lbww" target="_blank"><img class='social-icon' src={require('../assets/images/youtube.png')} alt="" title="" /></a></li>


						</ul>

					</div>

				</div>
				<div class="visit-ribbon" >
					<Row onClick={() => this.setState({ showVisit: true })}>
						<Col span={4}><img class="event-icon-ribbon" src={require('../assets/images/solicite.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></Col>
					
						<Col span={20}><br></br><div class="ribbon"><span>Solicite Visita Médica</span></div></Col>
					</Row>
				</div>
				{this.state.showVideo ? <div class="videoView">
					<div className="videoChild">
					<img class="close" onClick={() => this.setState({showVideo:false})} src={require('../assets/images/close.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />

						<div className='rcorners2' >
						<img class="event-icon-small-fixed" src={require('../assets/images/shield.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
						<br></br>
						<span class="home-text-small">{this.state.videoCategory}</span><br></br>
						<span class="text-h3">{this.state.videoTitle}</span><br></br><br></br>
							<ReactPlayer
							width={window.innerWidth > 1000 ? "800px" : "100%"}
							ref={this.ref}
							playing="playing"

							height={window.innerWidth > 1000 ? "430px" : "330px"}
								url={"https://player.vimeo.com/video/"+this.state.videoId+"?autoplay=1&loop=1&autopause=0"}
								controls="controls" />
							<br></br>
						
						</div>
					</div>

				</div> : <div></div>}
				{this.state.showVisit ? <div class="videoView">
					<div className="visitDiv">
						<img class="close" onClick={() => this.setState({ showVisit: false })} src={require('../assets/images/close.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />

						<div id="centered">
							<div className='rcorners2' >
								<br></br>
								<Row>
									<Col span={10}></Col>
									<Col span={12}>
										<span class="home-text-small">Gastro-In</span><br></br>
									</Col>
								</Row>
								<Row>
									<Col span={2}></Col>
									<Col span={20}>
										<span class="font-huge">Solicitud de Visita Médica</span><br></br><br></br>
										<span class="visit-text-blue">Nos podremos en contacto con usted en breve</span><br></br>
										<span class="visit-text">¿Cuál de los siguientes medios es el de su preferencia?</span><br></br>
										<Dropdown id="visitselect" overlayStyle={{ backgroundColor: "#000" }} overlay={<Menu>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "Correo electrónico" })}>
												<p className="dark-span" >Correo Electrónico</p>
											</Menu.Item>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "WhatsApp" })}>
												<p className="dark-span" >WhatsApp</p>

											</Menu.Item>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "Correo Electrónico y WhatsApp" })}>
												<p className="dark-span">Correo electrónico y WhatsApp</p>

											</Menu.Item>
										</Menu>} placement="bottomCenter">
											<div class="home-button-gray"><p className='clear-span'>{this.state.selectedVisit == '' ? "Seleccione su opción  " : this.state.selectedVisit}&nbsp;&nbsp;<Icon type="caret-down" style={{ fontSize: '16px', color: '#FFF' }} theme="outlined" /> </p></div>
										</Dropdown>
										<span class="visit-text">De click en ACEPTAR para confirmar su Solicitud de Visita Médica</span><br></br>

										{this.state.handleVisitLoader?<Spin tip="Enviando..."/>:
											<div class="home-button" onClick={this.handleVisits}><span>Aceptar</span></div>}									</Col>
								</Row>
								<Row>
									<Col span={6}></Col>

								</Row>
								<br></br>	<br></br>
								{this.state.visitStatus == "success" ? <span class="visit-text-blue">¡Su solicitud ha sido enviada!</span> : <div></div>}
								{this.state.visitStatus == "error" ? <span class="visit-text-blue">Se produjo un error</span> : <div></div>}

								<br></br>

							</div>
						</div>
					</div>
					

				</div> : <div></div>}
				
			</div>
		);
	}
}
const WrappedNormalForgetForm = Form.create()(Tarjeton);

export default connect(null, { userSignOut })(Tarjeton);
